export default __webpack_public_path__ + "static/media/zamowienia.5dc11a7d.svg";